import React from 'react'

const SkillsList = ({value: {title, level}}) => {
  return (
    <div className="skills__data">
        <div className="skills__title">
            <h3 className="skills__name">{title}</h3>
            <span className="skills__number">{level}</span>
        </div>

        <div className="skills__bar">
            <span className="skills__percentage skills__html"></span>
        </div>
    </div>
  )
}

export default SkillsList;